import axios from "axios";

import { baseAxios } from "config";

export const generateNaturalLanguageReport = async (data) => {
  try {
    const res = await baseAxios.post(`/reports/natural-language`, data);

    return res.data;
  } catch (err) {
    console.log("err: ", err);
    return err.response?.data || { success: false, error: "An unexpected error occurred" };
  }
};

export const refineNaturalLanguageQuery = async (data) => {
  try {
    const res = await baseAxios.post(`/reports/refine-query`, data);
    return res.data;
  } catch (err) {
    console.log("err: ", err);
    return err.response?.data || { success: false, error: "Failed to refine query" };
  }
};
